import { useCallback, useRef, useState } from "react";

/* The builder's quote state, readable at once. A setQ updater used to run whenever
   React got to it, so code after an await read the quote from the last render. Here
   every write computes against the latest quote immediately, so getQ() is always
   current. Used by DataProvider and the quotes test fixture. */
export function useLiveQuote(initial) {
  const [q, setState] = useState(initial);
  const ref = useRef(q);
  const setQ = useCallback((update) => {
    const next = typeof update === "function" ? update(ref.current) : update;
    if (next === ref.current) return;
    ref.current = next;
    setState(next);
  }, []);
  const getQ = useCallback(() => ref.current, []);
  return [q, setQ, getQ];
}
